










































































































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import {
  ICProdProvider,
  ICProdProviderMethods,
  IContractProductAttachmentCategory
} from "@/models/providers/contractProduct";
import { PriceType } from "@/data/enums/contractProducts";

@Component({
  components: {
    "cprod-modify-link": () =>
      import("@/components/app/global/contractProducts/cProdModifyLink.vue")
  }
})
export default class CProdBreakdown extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Data

  public isProcessing = false;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get product() {
    return this.cProdData.product;
  }

  public get contractProduct() {
    return this.cProdData.contractProduct;
  }

  public get optionsByCategory() {
    return this.groupedByCategory(this.contractProduct.options);
  }

  public get attributesByCategory() {
    return this.groupedByCategory(this.contractProduct.attributes);
  }

  // Methods

  public isConvertedPrice(type: PriceType) {
    return type === PriceType.CONVERTED;
  }

  public isManualPrice(type: PriceType) {
    return type === PriceType.MANUAL;
  }

  public groupedByCategory(items) {
    const clonedItems = this.$_.cloneDeep(
      this.$_.sortBy(items, [
        "product.category.order",
        "product.category.name_translated",
        "product.category.name",
        "product_name"
      ])
    );

    const optionCategories: IContractProductAttachmentCategory[] = [];

    this.$_.forEach(clonedItems, (item: any) => {
      const categoryIndex = this.$_.findIndex(optionCategories, [
        "id",
        item.product.category.id
      ]);

      if (categoryIndex === -1) {
        optionCategories.push({
          id: item.product.category.id,
          name:
            item.product.category.name_translated || item.product.category.name,
          products: [item]
        });
        return;
      }

      optionCategories[categoryIndex].products.push(item);
    });

    return optionCategories;
  }
}
